import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import FundIcon from 'assets/images/funds/moneypool-2.png'
import Fund2Icon from 'assets/images/funds/moneyPool-1.svg'
import { ConvertJalaliDate } from 'utilities/helper/digitToMonth'
interface ISubHeaderProps {
    capital: number
    workingCapital: number
    intervalPotency: number
    date: string
    intervalShareIncome: number
    totalShares: number
    shareValueAmount: number
    cashinsAmount: number
    cashoutAmounts: number
    createDate: string
    imageId: number
    avatar: string | null
    name: string
    isFuckingManager: () => boolean
}
export default function SubHeader({
    capital,
    workingCapital,
    intervalPotency,
    date,
    intervalShareIncome,
    totalShares,
    shareValueAmount,
    cashinsAmount,
    cashoutAmounts,
    createDate,
    imageId,
    avatar,
    name,
    isFuckingManager,
}: ISubHeaderProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const { state } = useLocation()
    return (
        <div className=" bg-white w-full py-2">
            <p className=" text-center my-2">صندوق {name}</p>
            <div className=" flex px-4 py-4 w-full items-center justify-start">
                <img
                    src={avatar ? avatar : imageId === 2 ? FundIcon : Fund2Icon}
                    alt="fund"
                    className=" w-20 h-20 rounded-full"
                />
                <div className=" md:mr-10 lg:mr-10">
                    <div className=" flex justify-between w-full mx-2  text-gray-4 text-center">
                        <p className="text-center">سرمایه صندوق</p>
                        <p className="text-center">
                            {capital && capital.toLocaleString()}
                        </p>
                    </div>
                    <div className=" flex justify-between w-full mx-2  text-gray-4 text-center">
                        <p className="text-center">سرمایه در گردش</p>
                        <p className="text-center">
                            {workingCapital && workingCapital.toLocaleString()}
                        </p>
                    </div>
                    <div className=" flex justify-between w-full mx-2  text-gray-4 text-center">
                        <p className="text-center">توان دوره</p>
                        <p className="text-center">
                            {intervalPotency &&
                                intervalPotency.toLocaleString()}
                        </p>
                    </div>
                    <div className=" flex justify-between w-full mx-2  text-gray-4 text-center">
                        <p className="text-center">تاریخ سررسید</p>
                        <p className="text-center">{ConvertJalaliDate(date)}</p>
                    </div>
                </div>
            </div>
            {isOpen && (
                <div className="transition-all duration-300 ease-in-out text-center border border-gray-1 bg-main-bg text-sm rounded-md mx-4 flex justify-center py-3 ">
                    <div>
                        <div className=" flex justify-between w-full mx-2  text-center my-2">
                            <p className="text-center text-gray-4 ">
                                ورودی ماهیانه
                            </p>
                            <p className="text-center">
                                {intervalShareIncome &&
                                    intervalShareIncome.toLocaleString()}
                                تومان
                            </p>
                        </div>
                        <div className=" flex justify-between w-full mx-2  text-center my-2">
                            <p className="text-center text-gray-4 ">
                                تعداد سهم ورودی
                            </p>
                            <p className="text-center ">
                                {totalShares && totalShares.toLocaleString()}
                                سهم
                            </p>
                        </div>
                        <div className=" flex justify-between w-full mx-2  text-center my-2">
                            <p className="text-center text-gray-4 ">
                                حق عضویت پایه
                            </p>
                            <p className="text-centertext-lg">
                                {shareValueAmount &&
                                    shareValueAmount.toLocaleString()}
                                تومان
                            </p>
                        </div>
                        <div className=" flex justify-between w-full mx-2  text-center my-2">
                            <p className="text-center text-gray-4 ">
                                مجموع واریزها
                            </p>
                            <p className="text-center">
                                {cashinsAmount &&
                                    cashinsAmount.toLocaleString()}
                                تومان
                            </p>
                        </div>
                        <div className=" flex justify-between w-full mx-2 text-center my-2">
                            <p className="text-center text-gray-4 ">
                                مجموع برداشت ها
                            </p>
                            <p className="text-center">
                                {cashoutAmounts &&
                                    cashoutAmounts.toLocaleString()}
                                تومان
                            </p>
                        </div>
                        <div className=" flex justify-between w-full mx-2  text-center my-2">
                            <p className="text-center text-gray-4 ">
                                تاریخ ایجاد صندوق
                            </p>
                            <p className="text-center">
                                {ConvertJalaliDate(createDate)}
                            </p>
                        </div>
                    </div>
                </div>
            )}
            <div className=" justify-center flex -mt-2 ">
                <button
                    className="py-1 px-2 border border-placeholder  text-center text-sm text-blue-1 rounded-b-lg my-2 bg-main-bg"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {isOpen ? 'اطلاعات کمتر' : 'اطلاعات بیشتر'}
                </button>
            </div>
        </div>
    )
}
